import { useState } from 'react'

export default function TimeLine() {
    const [currentStep, setCurrentStep] = useState(1)
    const handleClick = (step) => {
        setCurrentStep(step)
    }

    const timeline = [
        {
            image: '1.svg',
            imageAlt:
                'An icon of a dark grey location pin with a small orange house inside, all set against a gradient orange and yellow circular background.',
            imageTitle: 'Home location pin icon.',
            title: 'The Genesis',
            time: '(2010-2011)',
            desc: 'My foray into real estate was born out of necessity and curiosity. After six months of searching for houses with an agent, balancing a demanding job, and nurturing a newborn, I bought my first house in May 2011. This gut rehab project, completed over eight grueling months, netted a profit of $23,000. It was during this time I discovered the untapped potential of direct-to-seller marketing.',
        },
        {
            image: '2.svg',
            imageAlt:
                'An icon of a dark gray open envelope with an orange interior.',
            imageTitle: 'Email success or confirmed mail icon.',
            title: 'The Revelation',
            time: '(2012-2013)',
            desc: 'My second property, a fire-damaged house acquired through direct mail, was a game-changer. The success of this project, yielding an $84,000 profit, was a testament to the power of direct-to-seller marketing. I dove headfirst into refining my marketing strategies - experimenting with list creation, campaign designs, envelope colors, font styles, and more. These tweaks led to a surge in responses and deals, pushing me towards the realm of wholesaling.',
        },
        {
            image: '3.svg',
            imageAlt:
                'An icon of a bar graph with a rising, zig-zagging dark grey line and arrow pointing up, set against a gradient orange circular background.',
            imageTitle: 'Increasing trend or growth chart icon.',
            title: 'A Leap of Faith',
            time: '(2015-2016)',
            desc: 'By 2015, my marketing strategies were yielding results far superior to anything else in the market. A rigorous test of my methods against traditional yellow letter campaigns revealed a staggering 26.7% increase in response rates. This breakthrough was the catalyst for Open Letter Marketing. In 2016, leaving a stable job and embracing the uncertainty of entrepreneurship, I launched this venture to empower other real estate investors with unparalleled marketing tools and strategies.',
        },
    ]

    return (
        <div className="container mx-auto md:pt-28 px-8 space-y-8">
            <h3 className="font-bold text-3xl md:text-[55px] md:leading-[64.57px] leading-[35.22px] text-center">
                <span>How everything </span>
                <span className="olm-gradient-text">started</span>
            </h3>
            <div>
                <div className="md:w-[70%] flex items-center max-w-screen-lg mx-auto px-4 lg:overflow-visible overflow-x-scroll scrollbar-hide">
                    {timeline.map((t, i) => {
                        const step = i + 1
                        return (
                            <div key={step} className="flex items-center h-44">
                                <div className="relative">
                                    <div
                                        className={`w-20 h-20 shrink-0 mx-[-1px] p-[2px] rounded-full cursor-pointer ${
                                            currentStep === step
                                                ? 'olm-gradient'
                                                : 'bg-[#d9d9d9]'
                                        }`}
                                        onClick={() => handleClick(step)}>
                                        <span className="flex items-center justify-center w-full h-full rounded-full bg-white">
                                            <span
                                                className={`text-[30px] leading-[40px] font-bold ${
                                                    currentStep === step
                                                        ? 'olm-gradient-text'
                                                        : 'text-[#d9d9d9]'
                                                }`}>
                                                0{step}
                                            </span>
                                        </span>
                                    </div>
                                    <p
                                        className={`absolute w-[10rem] text-center text-[18px] leading-[22px] cursor-pointer left-1/2 -translate-x-1/2 font-semibold ${
                                            currentStep === step
                                                ? 'text-[#373D45]'
                                                : 'text-[#d9d9d9]'
                                        }`}
                                        onClick={() => handleClick(step)}>
                                        {t.title}
                                        <br />
                                        {t.time}
                                    </p>
                                </div>
                                {step !== timeline.length && (
                                    <div
                                        className={`w-52 h-1 ${
                                            currentStep - 1 === step
                                                ? 'olm-gradient'
                                                : 'bg-[#d9d9d9]'
                                        }`}></div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
            {timeline.map((t, i) => {
                const step = i + 1
                return (
                    <div
                        key={i}
                        className={`md:flex-row md:py-12 md:px-16 items-center flex-col bg-white p-8 ring-2 ring-gray-50 rounded-xl shadow_box ${
                            currentStep === step ? 'flex' : 'hidden'
                        }`}>
                        <div className="md:w-1/3 w-full text-center">
                            <img
                                className="mx-auto"
                                src={`/assets/about-us/timeline/${t.image}`}
                                alt={t.imageAlt}
                                title={t.imageTitle}
                            />
                        </div>
                        <div className="md:w-2/3 w-full px-4 py-3">
                            <h3 className="md:text-[35px] text-[25px] leading-[30px] font-bold py-5">
                                {t.title} <br className="md:hidden block" />
                                {t.time}
                            </h3>
                            <p className="md:text-lg md:leading-[28px] leading-[25px] text-[#151920] text-base">
                                {t.desc}
                            </p>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
